<script setup>
import { pageTransition } from '~/helpers/animations/animations';

definePageMeta({
  pageTransition: pageTransition,
});

const { t } = useI18n();
const route = useRoute();

const partnerQuery = gql`
  query GetPartnerData($slug: String!) {
    partner(slug: $slug) {
      seo_meta_title
      seo_meta_description
      seo_meta_keywords
      seo_url_slug {
        cs
        en
      }
      name
      url
      image_detail
      content
      group {
        id
        name
      }
      events {
        id
        name
        type
        image: image_list {
          url
        }
        imageCrop: image_list_crop_to
        slug: seo_url_slug {
          cs
          en
        }
        buildings {
          id
          name
        }
        dates {
          id
          start_at {
            timestamp
          }
          end_at {
            timestamp
          }
        }
      }
    }
  }
`;

const routeParams = computed(() => ({
  cs: { slug: data.value?.partner.seo_url_slug.cs },
  en: { slug: data.value?.partner.seo_url_slug.en },
}));

const { data } = await useAsyncQuery(partnerQuery, {
  slug: route.params.slug,
});
const partner = computed(() => data.value?.partner);

const breadcrumbs = ref([
  {
    title: t('pages.about.index.breadcrumbs-title'),
    route: 'about',
  },
  {
    title: t('pages.partners.breadcrumbs-title'),
    route: 'about-partners',
  },
  { title: t('pages.about.partners.detail.breadcrumbs-title') },
]);

onMounted(() => {
  if (data.value?.partner.seo_url_slug) {
    // $store.dispatch('i18n/setRouteParams', routeParams.value);
  }
});

const content = computed(() => {
  return partner.value && partner.value.content ? JSON.parse(partner.value.content).blocks : [];
});

useHeadData({
  title: partner.value?.seo_meta_title || partner.value?.name || null,
  description: partner.value?.seo_meta_description || null,
  keywords: partner.value?.seo_meta_keywords || null,
  image: partner.value?.image_detail || partner.value?.cropped_detail_image || null,
  url: route.fullPath,
});
</script>

<template>
  <main class="main">
    <Breadcrumbs :items="breadcrumbs" />
    <div v-if="partner" class="container-max-content">
      <a v-if="partner.url" :href="partner.url" target="_blank">
        <img :src="useGetImageUrl(partner.image_detail, partner.group.id == 1 ? 370 : 175, partner.group.id == 1 ? 170 : 85, 'png')" :alt="partner.name" class="partner-logo" />
      </a>
      <img v-else :src="useGetImageUrl(partner.image_detail, partner.group.id == 1 ? 370 : 175, partner.group.id == 1 ? 170 : 85, 'png')" :alt="partner.name" class="partner-logo" />
      <h1 class="heading mt-5">{{ partner.name }}</h1>
      <DynamicPageContent :content="content" class="mt-3" />
      <div v-if="partner.events.length" class="mt-5">
        <h2 class="heading heading--2 heading--thin">
          {{ t('pages.partners.detail.events') }}
        </h2>
        <EventGrid :data="partner.events" class="mt-3" />
      </div>
    </div>
  </main>
</template>

<style lang="scss">
.partner-logo {
  max-width: 100%;
}
</style>
